import {createAction} from "redux-act";
import {IError} from "modules/types";
import {ModalType} from "modules/reducers";

export const showErrorModal = createAction<IError>();
export const hideErrorModal = createAction();

export const showSuccessModal = createAction<string>();
export const hideSuccessModal = createAction();

export const openModal = createAction<ModalType>();
export const hideModal = createAction<ModalType>();

export const showBadgeModal = createAction<string>();
export const hideBadgeModal = createAction();
